import React,{useState,useEffect} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';
import questions from './data.json';
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import { Tab } from 'bootstrap';
import './fab.css'
// import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
class Fab extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            score:0
        }
    }
    onChange =  async (event) =>{
        const {name,value} = event.target
       await this.setState((prevState)=>({
            ...prevState,
            [name]:value
        }))
        this.props.handler('fab',this.state )
       
       
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    componentDidUpdate(prevProps,prevState){
        // if (prevState != this.state){
        //     this.props.handler('fab',this.state )
        // }
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
            
        }
    }
    render(){
        const a = questions.questions
        
        return(
           <div>
                <Container>
                <h2 style={{textAlign: 'center'}}>Frontal Assessment Battery</h2>
                <Questions_Table title= 'fab' score={true} scoreFunc={this.Scoring} questions={questions} data={this.props.data} disabled={this.props.disabled} answers={questions} handler={this.onChange} fieldName={'fab'}/>
                <Table>
                    <thead>
                        <tr>
                            <th>Score:</th>
                            <th><p className={'score'}>{this.state.score}</p></th>
                        </tr>
                    </thead>
                </Table>
                </Container>
            </div>
        )
    }
}
Fab.defaultProps = {
    data:null,
    disabled:false
}
export default Fab